import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive } from 'styles/constants';
import { WEB_APP_CTA_MAX_WIDTH } from 'utils/constants';

export const displayValueStyleProps = () => ({
  background: 'transparent',
  minWidth: 5,
  width: 5,
  _text: {
    fontSize: 18,
  },
});

export const incrementorStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  padding: 1,
  borderRadius: 20,
  borderWidth: 1,
  margin: 0.5,
  borderColor: getDesignToken(disabled ? 'icon-disabled' : 'icon-default'),
  _icon: {
    color: getDesignToken(disabled ? 'icon-disabled' : 'icon-default'),
    size: 6,
  },
});

export const ActionsWrapper = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[styles.actionsWrapper, isDesktop && styles.actionsWrapperDesktop, style]}
    />
  );
};

// Footer Styles
type BoxChildProps = BoxProps & {
  lastChild: boolean;
  spaces?: number;
};

export const BoxChild = ({ lastChild, spaces, style, ...props }: BoxChildProps) => (
  <Box
    {...props}
    style={[styles.boxChild, { flex: spaces || 1, marginRight: lastChild ? 0 : 16 }, style]}
  />
);

export const FooterWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.footerWrapper, style]} />
);

const styles = StyleSheet.create({
  actionsWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidth: WEB_APP_CTA_MAX_WIDTH,
    paddingHorizontal: 16,
    width: '100%',
  },
  actionsWrapperDesktop: {
    paddingHorizontal: 0,
  },
  boxChild: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerWrapper: {
    backgroundColor: getDesignToken('background-pattern'),
    borderTopColor: primitive.$blackOpacity4,
    borderTopWidth: 1,
    flexDirection: 'row',
    paddingBottom: 24,
    paddingTop: 24,
    width: '100%',
  },
});
